// ----------------------------------------------------------------------

/**
 * Overrides default MUI Typography component styles.
 * @param {object} theme The theme object.
 * @returns {object} An object with the overridden styles.
 * @example
 * const theme = {
 *   spacing: 8,
 * };
 * const styles = Typography(theme);
 */
/**
 * @prop {object} MuiTypography - The Typography component.
 * @prop {object} MuiTypography.styleOverrides - The styles to override.
 * @prop {object} MuiTypography.styleOverrides.paragraph - The styles for the paragraph variant.
 * @prop {number} MuiTypography.styleOverrides.paragraph.marginBottom - The margin bottom.
 * @prop {object} MuiTypography.styleOverrides.gutterBottom - The styles for the gutterBottom variant.
 * @prop {number} MuiTypography.styleOverrides.gutterBottom.marginBottom - The margin bottom.
 */
export default function Typography(theme) {
  return {
    MuiTypography: {
      styleOverrides: {
        paragraph: {
          marginBottom: theme.spacing(2),
        },
        gutterBottom: {
          marginBottom: theme.spacing(1),
        },
      },
    },
  };
}
